module.exports = {
  date: {
    type: 10, // 类型
    range_status: 0, // 是否选择范围
    date_min: { // 可选最小值配置
      type: 10, // 类型
      var_limit: '', // 变量限制
      fixed_value: '' // 固定日期
    },
    date_max: { // 可选最小值配置
      type: 10, // 类型
      var_limit: '', // 变量限制
      fixed_value: '' // 固定日期
    },
    date_default: { // 默认值
      is_null: 1, // 是否为空，1空，0非空
      single: '', // 不是范围：公式
      range_start: '', // 范围：开始公式
      range_end: '' // 范围：结束公式
    },
    quick_config: [] // 快捷选项
  }
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/date.js